module.exports = __webpack_public_path__ + "media/images/athletes/546-f2eefebafc0b8ba5b0b16e3e526101f4.png";